// Page-specific styles for the PlatformSelectionPage radio cards.
// Shared form atoms (label, button, message) live in
// ../../components/onboarding/onboarding-form.styles.ts.

import type { CSSProperties } from "react";

export const cardGroup: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-3)",
};

const baseCard: CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "var(--sz-space-3)",
  padding: "14px 18px",
  background: "var(--sz-bg-surface-2)",
  border: "1px solid var(--sz-border-default)",
  borderRadius: "var(--sz-radius-md)",
  cursor: "pointer",
  transition: "border-color var(--sz-duration-fast), background var(--sz-duration-fast)",
};

export const card: CSSProperties = baseCard;

export const cardSelected: CSSProperties = {
  ...baseCard,
  borderColor: "var(--sz-amber)",
  background: "var(--sz-amber-glow)",
};

export const cardInput: CSSProperties = {
  accentColor: "var(--sz-amber)",
  width: "16px",
  height: "16px",
};

export const cardBody: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "2px",
  flex: 1,
};

export const cardTitle: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-md)",
  color: "var(--sz-text-primary)",
  fontWeight: 500,
};

export const cardSlug: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-sm)",
  letterSpacing: "1.5px",
  color: "var(--sz-text-muted)",
};

export const disclaimer: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-text-muted)",
  lineHeight: 1.55,
  borderLeft: "2px solid var(--sz-border-default)",
  paddingLeft: "var(--sz-space-3)",
};
